export const DYNAMIC_CONTENT_BUILDER = 'DynamicContentBuilder';
export const DCB_IN_BEE_EDITOR = 'DynamicContentBuilderInBeeEditor';
